import ProductShadowBase from "../productShadowBase";
import DogEntry from "./Entry";

export default class DogEntryElement extends ProductShadowBase {
  connectedCallback() {
    this.loadAndRender(() => (
      <DogEntry
        backendHost={this.backendHost ?? undefined}
        appPathPrefix={this.appPathPrefix ?? undefined}
        skipCart={this.skipCart}
        channel={this.channel ?? undefined}
        language={this.language ?? undefined}
      />
    ));
  }
}
